import { gql } from '@apollo/client'

export const getAllUsers = gql`
    query GetAllUsers($pageSize: Int, $page: Int, $rcUserId: String) {
        getAllUsers(pageSize: $pageSize, page: $page, rcUserId: $rcUserId) {
            users {
                id
                createdAt
                updatedAt
                email
                role
                appleSub
                googleSub
                isAgreementChecked
                premiumExpiryDate
                fcmId
                rcUserId
                store
                isOrganic
                isPremium
            }
            totalCount
        }
    }
`

export const getUser = gql`
    query GetUser($userId: String!) {
        getUser(userId: $userId) {
            id
            createdAt
            updatedAt
            email
            role
            appleSub
            googleSub
            isAgreementChecked
            premiumExpiryDate
            fcmId
            rcUserId
            store
            isOrganic
            totalRevenue
            totalCredit {
                total
                dailyCredit
            }
            moderations {
                total
                blackLists {
                    id
                    prompt
                    inputImg
                    type
                    category
                    userId
                    createdAt
                }
            }
            usedCreditCount
            isPremium
        }
    }
`

export const getAllvideos = gql`
query GetAllVideos($status: StatusEnum, $model: ModelEnum, $rcUserId: String, $pageSize: Int, $page: Int, $startDate: DateTime, $endDate: DateTime) {
  getAllVideos(status: $status, model: $model, rcUserId: $rcUserId, pageSize: $pageSize, page: $page, startDate: $startDate, endDate: $endDate) {
    videos {
      id
      createdAt
      updatedAt
      model
      status
      prompt
      thumbnailUrl
      progressRatio
      type
      url
    }
    totalCount
  }
}
`
export const getVideo = gql`
    query GetVideo($videoId: String!) {
        getVideo(videoId: $videoId) {
            id
            createdAt
            updatedAt
            taskId
            userId
            model
            url
            status
            prompt
            category
            thumbnailUrl
            title
            motionScore
            style
            progressRatio
            aspectRatio
            upScale
            inputImageUrl
            errorReason
            seconds
            resolution
            feed {
                id
                status
            }
        }
    }
`

export const getAllCreditsAdmin = gql`
    query getAllCreditsAdmin {
        getAllCredits {
            amount
            rcEventId
            id
            user {
                id
                email
            }
            date
        }
    }
`
export const getHomePageVideos = gql`
    query GetHomePageVideos {
        getHomePageVideos {
            category
            createdAt
            id
            motionScore
            progressRatio
            prompt
            status
            style
            taskId
            thumbnailUrl
            title
            updatedAt
            url
        }
    }
`
export const getAllStyles = gql`
    query GetAllStyles {
        getAllStyles {
            banner
            createdAt
            id
            name
            updatedAt
            value
        }
    }
`
export const getExplorePage = gql`
    query GetAdminExplores {
        getAdminExplores {
            aspectRatio
            createdAt
            id
            motionScore
            prompt
            style
            thumbnailUrl
            updatedAt
            gif
            categoryId
            url
        }
    }
`
export const getExploreVideo = gql`
    query GetExploreVideo($exploreId: String!) {
        getExploreVideo(exploreId: $exploreId) {
            id
            url
            prompt
            thumbnailUrl
            motionScore
            style
            webmUrl
            region
            createdAt
            updatedAt
            aspectRatio
            lowResolutionUrl
            gif
            webmUrl
            exRegion
            categoryId
        }
    }
`
export const getUserCreditHistory = gql`
    query GetUserCreditHistory($userId: String!) {
        getUserCreditHistory(userId: $userId) {
            id
            userId
            creditId
            amount
            transactionId
            createdAt
            updatedAt
        }
    }
`
export const dashboardUserVideos = gql`
    query DashboardUserVideos($userId: String!) {
        dashboardUserVideos(userId: $userId) {
            id
            createdAt
            updatedAt
            taskId
            url
            status
            prompt
            category
            thumbnailUrl
            progressRatio
            aspectRatio
            upScale
            title
            motionScore
            style
        }
    }
`
export const getDashboardData = gql`
    query DashboardData {
        dashboardData {
            totalVideo
            totalUser
            pieChartData {
                failed
                running
                in_queue
                throttled
                succeeded
                pending
            }
            lastCreatedVideoData
            dailyVideoCount {
                date
                count
            }
            activeSubscriptions
        }
    }
`
export const getCategories = gql`
query GetCategories($pageSize: Int, $page: Int) {
  getCategories(pageSize: $pageSize, page: $page) {
    id
    name
    rowNumber
  }
}
`
export const getCategory = gql`
query GetCategory($categoryId: String!) {
  getCategory(categoryId: $categoryId) {
    id
    name
    rowNumber
    createdAt
    updatedAt
    tools {
      id
      name
    }
  }
}
`
export const getSystem = gql`
    query GetSystem($systemType: SystemTypeEnum!) {
        getSystem(systemType: $systemType) {
            id
            provider
            type
            createdAt
            updatedAt
        }
    }
`
export const getAdminFeed = gql`
  query GetAdminFeed($pageSize: Int, $page: Int, $status: FeedStatus, $rcUserId: String, $aspectRatio: AspectRatioEnum) {
    getAdminFeed(pageSize: $pageSize, page: $page, status: $status, rcUserId: $rcUserId, aspectRatio: $aspectRatio) {
      feed {
        likeCount
        id
        status
        user {
          userName
        }
        video {
          thumbnailUrl
          id
          url
        }
      }
      count
    }
  }
`;
export const getCredit = gql`
    query GetCredit($creditId: String!) {
        getCredit(creditId: $creditId) {
            id
            createdAt
            updatedAt
            date
            amount
            rcEventId
            productName
            productType
            expiryDate
            transactionId
            isPromo
        }
    }
`
export const supportAdmin = gql`
    query SupportAdmin($rcUserId: String!) {
        supportAdmin(rcUserId: $rcUserId) {
            credits {
                id
                createdAt
                updatedAt
                date
                amount
                rcEventId
                productName
                productType
                expiryDate
                transactionId
                isPromo
            }
            user {
                id
                createdAt
                updatedAt
                email
                role
                appleSub
                googleSub
                userName
                isAgreementChecked
                premiumExpiryDate
                fcmId
                rcUserId
                store
                firstSeenLocation
                totalCredit {
                    total
                }
                usedCreditCount
                isPremium
                videos {
                    id
                    status
                }
                lastSeenLocation
            }
            videoAnalyticData {
                succeeded
                failed
                total
                refund
            }
        }
    }
`


export const GET_USER_BY_ID = gql`
  query GetUserById($id: ID!) {
    user(id: $id) {
      id
      name
      email
      username
      phone
      address
      status
      createdAt
    }
  }
`;


export const getCreditStats = gql`
  query GetCreditStats($endDate: String, $startDate: String) {
  getCreditStats(endDate: $endDate, startDate: $startDate) {
    date
    creditCounts {
      weekly
      monthly
      yearly
      tier1
      tier2
      tier3
      oneTime
    }
    totalCount
  }
}
`;
export const getBasicStats = gql`
query GetBasicStats {
    getBasicStats {
      totalUsers
      totalVideos
      activeSubscriptions
      lastVideoDate
    }
  }
`;

export const getDailyVideoStats = gql`
query GetDailyVideoStats($endDate: String, $startDate: String) {
    getDailyVideoStats(endDate: $endDate, startDate: $startDate) {
      date
      count
    }
  }
`;

export const getVideoStatusStats = gql`
query GetVideoStatusStats($endDate: String, $startDate: String) {
    getVideoStatusStats(endDate: $endDate, startDate: $startDate) {
      failed
      running
      in_queue
      throttled
      succeeded
      pending
    }
  }
`;

export const getVideoTypeStats = gql`
query GetVideoTypeStats($endDate: String, $startDate: String) {
    getVideoTypeStats(endDate: $endDate, startDate: $startDate) {
      img2Video
      text2Video
      toolPredict
      storyBoard
      total
    }
  }
`;

export const getAllCreditProducts = gql`
  query GetAllCreditProducts($filter: CreditProductFilterInput, $pagination: CreditProductPaginationInput!) {
    getAllCreditProducts(filter: $filter, pagination: $pagination) {
      total
      hasMore
      items {
        id
        name
        amount
        startDate
        endDate
        limit
        price
        type
        createdAt
        updatedAt
        creditCount
        isActive
        isExpired
        isUpcoming
      }
    }
  }
`

export const getCreditProductById = gql`
  query GetCreditProductById($getCreditProductByIdId: String!) {
    getCreditProductById(id: $getCreditProductByIdId) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
    }
  }
`

export const getAllTools = gql`
query GetAllTools($filter: StudioFilterInput) {
  getAllTools(filter: $filter) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    webmUrl
    webpUrl
    rowNumber
    templateId
    prompt
    isFeatured
    duration
    model
    categoryId
    cost
    provider
    createdAt
    updatedAt
    videoCount
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const getTool = gql`
query GetTool($getToolId: String!) {
  getTool(id: $getToolId) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    rowNumber
    templateId
    prompt
    isFeatured
    duration
    categoryId
    cost
    provider
    createdAt
    updatedAt
    videoCount
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`